import { render, staticRenderFns } from "./FlagButton.vue?vue&type=template&id=d00a9196&"
import script from "./FlagButton.vue?vue&type=script&lang=js&"
export * from "./FlagButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports